import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const marketingApi = {
    createV2Discount: async (item) => {
        const url = 'api/discounts/v2';
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
        return response;
    },
    uploadCustomerIdCsvFileForDiscountCode: async (customerIdCsvFile, discountCode) => {
        const formData = new FormData();
        formData.append('customerIDList', customerIdCsvFile);

        const url = `api/discounts/v2/customerList/${discountCode}/append`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
    downloadCustomerIdCsvFileForDiscountCode: async (discountID) => {
        const filename = `customerIdList-${discountID}.csv`;
        const url = `api/discounts/v2/customerList/${discountID}/csv`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadCustomerIdListCSV] error', e.toString());
        }
    },
    getAllReferralRewards: async () => {
        const url = `api/marketing/v1/referrals/list`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getReferralRewards: async () => {
        const url = `api/marketing/v1/referrals/credit`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getDiscounts: async () => {
        const url = `api/discounts/v2?firstUseOnly=true&limitedReferral=true`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getDiscount: async (discountID) => {
        const url = `api/discounts/v2/${discountID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    disableDiscount: async (discountID) => {
        const url = `api/discounts/v2/disable`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ discountID }),
        });
        return response;
    },
    updateV2Discount: async (discountId, claimBy, useBy, nanobarText, nanobarTerms) => {
        const url = `api/discounts/v2/modify`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({
                discountID: discountId,
                claimBy,
                useBy,
                nanobarText,
                nanobarTerms,
            }),
        });
        return response;
    },
    updateReferralRewards: async (item) => {
        const url = `api/marketing/v1/referrals/credit`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
        return response;
    },
    getProduceList: async () => {
        const url = `api/marketing/v1/produceList`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    createProduceListItem: async ({ countryOfOrigin, image, itemName, rankNumber }) => {
        const formData = new FormData();

        formData.append('itemName', itemName);
        formData.append('image', image);
        formData.append('countryOfOrigin', countryOfOrigin);
        formData.append('rankNumber', rankNumber);

        const url = `api/marketing/v1/produceList`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
    updateProduceListItem: async (id, item) => {
        const formData = new FormData();
        Object.keys(item).forEach((key) => {
            formData.append(key, item[key]);
        });

        const url = `api/marketing/v1/produceList/${id}`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
    deleteProduceListItem: async (id) => {
        const url = `api/marketing/v1/produceList/${id}`;
        const response = await mmFetchWithResponse(url, {
            method: 'DELETE',
        });
        return response;
    },
    getVipCustomerList: async () => {
        const url = `api/marketing/v1/vipCustomerList`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    deleteVipCustomer: async (id) => {
        const url = `api/marketing/v1/vipCustomerList/${id}`;
        const response = await mmFetchWithResponse(url, {
            method: 'DELETE',
        });
        return response;
    },
    uploadVipCustomers: async (customerFile) => {
        const formData = new FormData();
        formData.append('customerFile', customerFile);

        const url = `api/marketing/v1/vipCustomerList`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
    getAcquisitionPDPs: async () => {
        const url = 'api/catalog/v1/acquisition-pdps';
        return mmFetchWithResponse(url);
    },
    generateAcquisitionPDPs: async () => {
        const url = 'api/catalog/v1/acquisition-pdps';
        return mmFetchWithResponse(url, { method: 'PUT' });
    },
};

export { marketingApi };
